module.exports = __webpack_public_path__ + "img/core-active-1.440d7d6.png";